import { Component, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';

import { PhoneNumber } from '../../../models/phone-number';

import { PhoneNumberService } from '../../../services/contacts/phone-number.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-phone-number-form',
  templateUrl: './phone-number-form.component.html',
  styleUrls: ['./phone-number-form.component.scss'],
})
export class PhoneNumberFormComponent implements OnInit, OnChanges {
  /**
   * Contact id for phone number
   */
  @Input() contactId: number;

  /**
   * Phone number being created/edited
   */
  @Input() phoneNumber: PhoneNumber = new PhoneNumber();

  /**
   * Emit saved event to parent component
   * @param {EventEmitter<boolean> = new EventEmitter(} ) saved Event emitter to emit saved event to parent component
   */
  @Output() saved: EventEmitter<boolean> = new EventEmitter();

  /**
   * Default form options
   * @type {any}
   */
  formOptions: any = {
    phone_types: [],
  };

  /**
   * Indicates if form has been submitted atleast once
   * @type {boolean}
   */
  formSubmitted: boolean = false;

  /**
   * Indicates if form is processing
   * @type {boolean}
   */
  formSubmitting: boolean = false;

  /**
   * Inject dependencies
   * @param {PhoneNumberService} private phoneNumberService Service for phone number resource
   * @param {NotyService}        private notyService        Service for UI notification
   */
  constructor(private phoneNumberService: PhoneNumberService, private notyService: NotyService) {
    this.phoneNumberService.formOptions().then((response_json) => (this.formOptions = response_json));
  }

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Called when component variable changes
   * @param {SimpleChanges} changes Object with variables changed in component
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.phoneNumber.contact_id = this.contactId;
  }

  changed(number: any) {
    console.log(number);
  }

  normalizeNumber() {
    if (!this.phoneNumber.number) return;

    this.phoneNumber.number = this.phoneNumber.number
      .toString()
      .replace(/[‐‑‒–—―−]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Save Phone Number
   * @param {NgForm} currentForm Angular form
   */
  save(currentForm: NgForm) {
    this.formSubmitted = true;
    this.normalizeNumber();
    if (!currentForm.form.valid) {
      this.notyService.notify('Please check the form again', 'error', 5000, 'topRight');
      return;
    }
    this.formSubmitting = true;
    this.phoneNumberService
      .save(this.phoneNumber)
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Phone number saved', 'success', 5000, 'topRight');
          this.saved.emit(true);
          if (!this.phoneNumber.id) {
            this.phoneNumber = new PhoneNumber();
            this.phoneNumber.contact_id = this.contactId;
          }
        } else this.notyService.notify(response_json.text || 'Error saving phone number', 'error', 5000, 'topRight');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving phone number', 'error', 5000, 'topRight');
      });
  }
}
